import type { ConfirmationDialog as DxConfirmationDialog } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import MainTitle from '@components/MainTitle/MainTitle';
import {
  HorizontalFlex,
  VerticalFlex,
} from '@components/RecordCard/RecordCard.style';
import RoundedButton from '@components/RoundedButton/RoundedButton';

const messages = defineMessages({
  discard: {
    id: 'GLOBAL.discard',
    defaultMessage: 'Discard',
  },
  cancel: {
    id: 'GLOBAL.cancel',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'GLOBAL.delete',
    defaultMessage: 'Delete',
  },
  discardChanges: {
    id: 'confirmationDialog.discardChanges',
    defaultMessage: 'Discard unsaved changes?',
  },
  deleteRoutine: {
    id: 'confirmationDialog.deleteRoutine',
    defaultMessage: 'Are you sure you want to delete this routine?',
  },
});

/**
 * VITALL styled confirmation dialog component for confirming discard and delete operations
 */
const Layout = ({ ...props }: DxConfirmationDialog.LayoutProps) => {
  const { formatMessage } = useIntl();
  const { handleCancel, handleConfirm, isDeleting } = props;
  return (
    <>
      <MainTitle
        title={formatMessage(
          isDeleting ? messages.deleteRoutine : messages.discardChanges
        )}
      />
      <HorizontalFlex justifyContent="center">
        <VerticalFlex alignItems="center" style={{ padding: 9 }}>
          <RoundedButton
            autoSize
            height={40}
            onClick={handleConfirm}
            variant="red"
          >
            {formatMessage(isDeleting ? messages.delete : messages.discard)}
          </RoundedButton>
        </VerticalFlex>
        <VerticalFlex alignItems="center" style={{ padding: 9 }}>
          <RoundedButton
            autoSize
            height={40}
            onClick={handleCancel}
            variant="grey"
          >
            {formatMessage(messages.cancel)}
          </RoundedButton>
        </VerticalFlex>
      </HorizontalFlex>
    </>
  );
};

export default Layout;
